import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { Observer } from 'rxjs';

import {
    ParamField,
    QueryPart,
    QueryPartsToStructuredQuery,
    StructuredQuery,
    UrlQueryParamsConverter
} from '@stylehaven/components';
import { SavedQuery } from '../../entities/saved-queries/saved-query.entity';
import { LoadingBehaviorSubject } from '../../helpers';
import { LuceneParser } from '../../helpers/lucene-parser.helper';
import { RecordActionItem } from '../../record/entities/action/record-action-item.class';
import { AbstractActionCreator } from '../../services/actions/abstract-action.creator';
import { ProfilesService } from '../../services/profiles/profiles.service';

@Injectable()
export class RestoreSavedQueryActionCreator extends AbstractActionCreator {
    constructor(
        private readonly translateService: TranslateService,
        private luceneParser: LuceneParser,
        private router: Router,
        private profileService: ProfilesService
    ) {
        super();
    }

    getRestoreSavedQueryAction(loader$: LoadingBehaviorSubject, tag: string): RecordActionItem<SavedQuery> {
        const label = this.translateService.instant('actions.common.load');
        const action = new RecordActionItem<SavedQuery>(label);
        action.enablePredicate = query => true;
        action.callback = (query, observer) => this.restoreQuery(loader$, query, tag, observer);
        return action;
    }

    private restoreQuery(
        loader$: LoadingBehaviorSubject,
        query: SavedQuery,
        tag: string,
        observer: Observer<any>
    ): void {
        const queryParts: QueryPart[] = this.luceneParser.luceneQueryToQueryParts(query.Query.replace('*:*', ''));
        const structuredQuery: StructuredQuery = QueryPartsToStructuredQuery(queryParts);

        const advQueryParam: string = UrlQueryParamsConverter.advancedStructuredQueryToQueryParam(
            structuredQuery.AdvancedSearch
        );
        const qQueryParam: string = structuredQuery.Global.length > 0 ? structuredQuery.Global.join(',') : '';

        // The record overview resolves the active saved query from this id alone (its `activeQueryId$`),
        // and that is what names it under "Huidige zoekopdracht" and enables update/deactivate on it.
        // Navigating with only q/advQ applies the filter as an anonymous search (HFBD-167).
        const params = {
            q: qQueryParam !== '' ? qQueryParam : undefined,
            advQ: advQueryParam !== '' ? advQueryParam : undefined,
            [ParamField.SavedQuery]: query.Id
        };

        this.router.navigate(['/records'], { queryParams: params });
    }
}
